import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useLayoutEffect } from 'react';
import { Flex, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { Breadcrumb } from '../antd/navigation.js';
const { Title, Text } = Typography;
/**
 * Where a page's crumbs go when the host shell already draws a trail.
 *
 * A panel whose layout renders its own breadcrumb above every page provides
 * this (as `PageHeader.CrumbSlot`) with a setter. `PageHeader` then HANDS its
 * `crumbs` to the shell instead of drawing a second trail under the first —
 * two stacked bars, both repeating «بیماران», was what every detail page
 * showed. Without a provider the header draws its own trail, as before.
 */
const CrumbSlotContext = createContext(null);
function PageHeaderImpl({ title, description, crumbs, extra, tag }) {
    const registerCrumbs = useContext(CrumbSlotContext);
    // Keyed by content, not identity: call sites build the array inline, and a
    // fresh array every render must not re-publish (and re-render the shell).
    const crumbsKey = crumbs && crumbs.length > 0 ? JSON.stringify(crumbs) : null;
    // Only a header that HAS crumbs publishes. A crumb-less header nested in a
    // page (a tab, a drawer) must not clear the trail the page already set.
    useLayoutEffect(() => {
        if (!registerCrumbs || !crumbsKey)
            return undefined;
        registerCrumbs(JSON.parse(crumbsKey));
        return () => registerCrumbs(null);
    }, [registerCrumbs, crumbsKey]);
    return (_jsxs("div", { style: { marginBlockEnd: 'var(--bk-space-6)' }, children: [!registerCrumbs && crumbs && crumbs.length > 0 ? (_jsx(Breadcrumb, { style: { marginBlockEnd: 'var(--bk-space-2)' }, items: crumbs.map((crumb) => ({
                    title: crumb.to ? _jsx(Link, { to: crumb.to, children: crumb.label }) : crumb.label,
                })) })) : null, _jsxs(Flex, { align: "flex-start", justify: "space-between", gap: "var(--bk-space-4)", wrap: "wrap", children: [_jsxs("div", { style: { minInlineSize: 0 }, children: [_jsxs(Space, { size: "small", align: "center", wrap: true, children: [_jsx(Title, { level: 2, style: { margin: 0 }, children: title }), tag] }), description ? (_jsx(Text, { type: "secondary", 
                                // A reading measure. Unbounded, a long description ran as one
                                // ~1300px line on a wide screen.
                                style: {
                                    display: 'block',
                                    marginBlockStart: 'var(--bk-space-1)',
                                    maxInlineSize: '68ch',
                                }, children: description })) : null] }), extra ? _jsx(Space, { wrap: true, children: extra }) : null] })] }));
}
export const PageHeader = Object.assign(PageHeaderImpl, {
    /** See `CrumbSlotContext`. */
    CrumbSlot: CrumbSlotContext.Provider,
});
//# sourceMappingURL=page-header.js.map